import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export class Message {
  public it: string;
  public de: string;
  public en: string;
}

export class PushNotification {
  id: number;
  body: { it: string, de: string, en: string } | string;
  sentAt: string;
  title: string;
  image: string;
}

@Injectable({
  providedIn: 'root'
})
export class PushNotificationService {


  constructor(private _http: HttpClient) {

  }


  public submitPushNotification(orgId: string, message: string, file) {
    const formData = new FormData();
    formData.append('organizationId', orgId.toString());
    formData.append('message', message);
    if (file) {
      formData.append('image', file, file.name);
    }
    return this._http.post<any>(
      environment.serverUrl + 'notification/send',
      formData
    ).pipe(
      map(responseData => {
        return responseData;
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  public getPushNotification(orgId: string) {
    let paramas = new HttpParams();
    paramas = paramas.append('orgId', orgId);
    return this._http.get<any[]>(environment.serverUrl + 'notifications/get', {
      params: paramas,
    }).pipe(
      map(responseData => {
        // localStorage.setItem('orgId', responseData.organizationTypeId.toString());
        // this.organizationTypeSubject.next(responseData.organizationTypeId);
        return responseData.map((v, ...k) => ({ ...v, body: JSON.parse(v.body) }));
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }
}
